function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { SDKError as e, Fetch as t, getModuleApi as s, InfaceEnv as r, InfaceSDK as n } from "@inface-sdk/common";
function o() {
  return (o = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var s = arguments[t];
      for (var r in s) Object.prototype.hasOwnProperty.call(s, r) && (e[r] = s[r]);
    }
    return e;
  }).apply(this, arguments);
}
function i(e, t) {
  if (null == e) return {};
  var s,
    r,
    n = {},
    o = Object.keys(e);
  for (r = 0; r < o.length; r++) t.indexOf(s = o[r]) >= 0 || (n[s] = e[s]);
  return n;
}
var a = {
  FAILED_INITIALIZE: {
    CODE: 112101,
    MESSAGE: "Failed to initialize IM SDK during startup process"
  },
  FAILED_FINALIZE: {
    CODE: 112102,
    MESSAGE: "Failed to finalize IM SDK during stop process"
  },
  FAILED_ADD_LISTENERS: {
    CODE: 112103,
    MESSAGE: "Failed to add listeners"
  },
  FAILED_REMOVE_LISTENERS: {
    CODE: 112104,
    MESSAGE: "Failed to remove listeners"
  },
  FAILED_SUBSCRIBE: {
    CODE: 112105,
    MESSAGE: "Failed to subscribe livestream"
  },
  FAILED_UNSUBSCRIBE: {
    CODE: 112106,
    MESSAGE: "Failed to unsubscribe livestream"
  },
  FAILED_UNSUBSCRIBE_ALL: {
    CODE: 112107,
    MESSAGE: "Failed to unsubscribe all livestream"
  },
  IM_IS_NOT_STOPPED: {
    CODE: 112198,
    MESSAGE: "Failed to operate command, because IM is already started"
  },
  IM_IS_NOT_STARTED: {
    CODE: 112199,
    MESSAGE: "Failed to operate command, because IM is not started yet"
  },
  FAILED_SEND_MESSAGE: {
    CODE: 112201,
    MESSAGE: "Failed to send instant message"
  },
  FAILED_SEND_MESSAGE_NO_TARGET: {
    CODE: 112202,
    MESSAGE: "Failed to send instant message because no specific target"
  },
  FAILED_SEND_MESSAGE_LS_STOPPED: {
    CODE: 112203,
    MESSAGE: "Failed to send instant message because livestream stopped"
  },
  FAILED_ATTACH_AUTH: {
    CODE: 112204,
    MESSAGE: "Failed to attach auth"
  },
  FAILED_ACK_TOY_PUSH_MESSAGE_READ: {
    CODE: 112205,
    MESSAGE: "Failed send to ack for toy push message"
  },
  INVALID_PARAMETER: {
    CODE: 112301,
    MESSAGE: "Invalid Parameter"
  },
  UNKNOWN: {
    CODE: 112500,
    MESSAGE: "Unknown error occurs"
  }
};
a = Object.freeze(Object.assign({}, a));
for (var _i = 0, _Object$values = Object.values(a); _i < _Object$values.length; _i++) {
  var _e = _Object$values[_i];
  Object.freeze(_e);
}
var c = a;
function E(_ref) {
  var e = _ref.SDKError,
    t = _ref.error,
    _ref$event = _ref.event,
    s = _ref$event === void 0 ? "" : _ref$event,
    _ref$errorMessage = _ref.errorMessage,
    r = _ref$errorMessage === void 0 ? "Failed ".concat(s) : _ref$errorMessage,
    n = _ref.errorCode,
    _ref$payload = _ref.payload,
    o = _ref$payload === void 0 ? "" : _ref$payload;
  return t instanceof e ? t : new e().failedAction(r, n, s, {
    payload: o,
    error: t
  });
}
function _(_ref2) {
  var t = _ref2.code,
    s = _ref2.name,
    r = _ref2.message,
    n = _ref2.other;
  return new e().failedAction(r, t, s, n);
}
var d = ["gid"],
  h = function h(e) {
    var t = {};
    function s(e) {
      var t,
        s = "im";
      if (e) {
        if (e.type) {
          if ("string" == typeof e.type) {
            var _r = e.type.split("::").reverse();
            t = _r[0], s = _r[1] || "im";
          } else t = e.type.action || e.type.name || "UNKNOWN_EVENT_ACTION";
        } else t = e.action || e.name || "UNKNOWN_EVENT_ACTION";
      } else t = "UNKNOWN_EVENT_ACTION";
      return "".concat(s, "::").concat(t);
    }
    var r = function r(e, t) {
        var r = s(e);
        t && t(r, e && e.data ? e.data : {
          body: {}
        });
      },
      n = function n(e, t) {
        var r = s(e);
        t && t(r, e && e.data ? e.data : {
          body: {}
        });
      },
      i = function i(e, t) {
        var r = s(e);
        t && t(r, e && e.data ? e.data : {
          body: {}
        });
      },
      a = function a(e, s) {
        var o = {};
        return t.onMessage || (o.onMessage = function (t) {
          return r(t, e);
        }, t.onMessage = function (t) {
          return r(t, e);
        }), t.onEvent || (o.onEvent = function (t) {
          return n(t, e);
        }, t.onEvent = function (t) {
          return n(t, e);
        }), t.onError || (o.onError = function (e) {
          return i(e, s);
        }, t.onError = function (e) {
          return i(e, s);
        }), o;
      };
    return [{
      name: "initialize",
      action: function action(_ref3, d) {
        var s = _ref3.ok,
          r = _ref3.fail,
          n = _ref3.okGameAction,
          i = _ref3.failGameAction,
          _ = _ref3.SDKError;
        if (a(n, i), "attach_auth" === d.access_token_type) throw new Error("invalid access tokey type [".concat(d.access_token_type, "]"));
        try {
          e.initialize(o({
            onMessage: t.onMessage,
            onEvent: t.onEvent,
            onError: t.onError,
            ok: s,
            fail: r
          }, d));
        } catch (e) {
          return console.error(e), r(E({
            SDKError: _,
            error: e,
            event: "initialize",
            payload: d,
            errorCode: c.FAILED_INITIALIZE.CODE
          }));
        }
      }
    }, {
      name: "attach_auth",
      action: function action(_ref4, n) {
        var t = _ref4.ok,
          s = _ref4.fail,
          r = _ref4.SDKError;
        try {
          e.attachAuth(o({
            ok: t,
            fail: s
          }, n));
        } catch (e) {
          return console.error(e), s(E({
            SDKError: r,
            error: e,
            event: "attach_auth",
            payload: n,
            errorCode: c.FAILED_ATTACH_AUTH.CODE
          }));
        }
      }
    }, {
      name: "send_instant_message",
      action: function action(_ref5, n) {
        var t = _ref5.ok,
          s = _ref5.fail,
          r = _ref5.SDKError;
        try {
          if (!n.target) return s(E({
            SDKError: r,
            error: error,
            event: "sendInstantMessage",
            payload: n,
            errorCode: c.FAILED_SEND_MESSAGE_NO_TARGET.CODE
          }));
          if (!n.message) return s(E({
            SDKError: r,
            error: error,
            event: "sendInstantMessage",
            payload: n,
            errorCode: c.FAILED_SEND_MESSAGE_NO_TARGET.CODE
          }));
          e.sendInstantMessage(o({}, n)), t();
        } catch (e) {
          return s(E({
            SDKError: r,
            error: e,
            event: "sendInstantMessage",
            payload: n,
            errorCode: c.FAILED_SEND_MESSAGE.CODE
          }));
        }
      }
    }, {
      name: "subscribe",
      action: function action(_ref6, n) {
        var t = _ref6.ok,
          s = _ref6.fail,
          r = _ref6.SDKError;
        try {
          e.subscribe(o({}, n)), t();
        } catch (e) {
          return s(E({
            SDKError: r,
            error: e,
            event: "subscribe",
            payload: n,
            errorCode: c.FAILED_SUBSCRIBE.CODE
          }));
        }
      }
    }, {
      name: "unsubscribe",
      action: function action(_ref7, n) {
        var t = _ref7.ok,
          s = _ref7.fail,
          r = _ref7.SDKError;
        try {
          e.unsubscribe(o({}, n)), t();
        } catch (e) {
          return s(E({
            SDKError: r,
            error: e,
            event: "unsubscribe",
            payload: n,
            errorCode: c.FAILED_UNSUBSCRIBE.CODE
          }));
        }
      }
    }, {
      name: "unsubscribe_all",
      action: function action(_ref8, n) {
        var t = _ref8.ok,
          s = _ref8.fail,
          r = _ref8.SDKError;
        try {
          e.unsubscribeAll(o({}, n)), t();
        } catch (e) {
          return s(E({
            SDKError: r,
            error: e,
            event: "unsubscribeAll",
            payload: n,
            errorCode: c.FAILED_UNSUBSCRIBE_ALL.CODE
          }));
        }
      }
    }, {
      name: "add_listeners",
      action: function action(_ref9) {
        var t = _ref9.ok,
          s = _ref9.fail,
          r = _ref9.SDKError,
          n = _ref9.okGameAction,
          i = _ref9.failGameAction;
        var _ = a(n, i);
        try {
          e.addListeners(o({}, _)), t();
        } catch (e) {
          return s(E({
            SDKError: r,
            error: e,
            event: "addListeners",
            errorCode: c.FAILED_ADD_LISTENERS.CODE
          }));
        }
      }
    }, {
      name: "remove_listeners",
      action: function action(_ref10) {
        var s = _ref10.ok,
          r = _ref10.fail,
          n = _ref10.SDKError;
        var i = {};
        t.onMessage && (i.onMessage = t.onMessage), t.onEvent && (i.onEvent = t.onEvent), t.onError && (i.onError = t.onError);
        try {
          e.removeListeners(o({}, i)), s();
        } catch (e) {
          return r(E({
            SDKError: n,
            error: e,
            event: "removeListeners",
            errorCode: c.FAILED_REMOVE_LISTENERS.CODE
          }));
        }
      }
    }, {
      name: "ack_toy_push_message_read",
      action: function action() {
        var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          t = _ref11.ok,
          s = _ref11.fail,
          r = _ref11.SDKError;
        var n = arguments.length > 1 ? arguments[1] : undefined;
        try {
          var _s = n.svc_id,
            _r2 = n.push_id,
            _o = n.udid;
          if (!_s || !_r2 || !_o) return t();
          e.ackToyPushMessageRead({
            svcId: _s,
            pushId: _r2,
            udid: _o
          }), t();
        } catch (e) {
          return s(E({
            SDKError: r,
            error: e,
            event: "ack_toy_push_message_read",
            errorCode: c.FAILED_ACK_TOY_PUSH_MESSAGE_READ.CODE
          }));
        }
      }
    }, {
      name: "finalize",
      action: function action() {
        var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          s = _ref12.ok,
          r = _ref12.fail,
          n = _ref12.SDKError;
        try {
          e.finalize(), Object.keys(t).forEach(function (e) {
            return delete t[e];
          }), s();
        } catch (e) {
          r(E({
            SDKError: n,
            error: e,
            event: "finalize",
            payload: "",
            errorCode: c.FAILED_FINALIZE.CODE
          }));
        }
      }
    }];
  },
  S = Object.freeze(Object.assign({}, {
    IM_START: {
      CODE: 101,
      MESSAGE: "Instant Message started"
    },
    IM_STOP: {
      CODE: 102,
      MESSAGE: "Instant Message stopped"
    }
  }));
for (var _i2 = 0, _Object$values2 = Object.values(S); _i2 < _Object$values2.length; _i2++) {
  var _e2 = _Object$values2[_i2];
  Object.freeze(_e2);
}
var u = Object.freeze(Object.assign({}, {
    IM_EVENT: "im_event",
    LS_EVENT: "ls_event"
  })),
  l = function l(e) {
    return !(void 0 === e || "function" == typeof e);
  },
  A = ["pushId", "platform", "svcId", "udid", "utc", "npsn", "countryCode", "console"],
  p = ["pushId", "svcId", "udid"],
  g = ["platform", "utc"];
var f = /*#__PURE__*/function () {
  function f(e) {
    _classCallCheck(this, f);
    this._baseUrl = e;
  }
  return _createClass(f, [{
    key: "sendReceiveAck",
    value: function () {
      var _sendReceiveAck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
        var t;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              t = this._createUrl("/sdk/push/ack");
              return _context.abrupt("return", this._post(t, JSON.stringify(e)));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function sendReceiveAck(_x) {
        return _sendReceiveAck.apply(this, arguments);
      }
      return sendReceiveAck;
    }()
  }, {
    key: "sendReadAck",
    value: function () {
      var _sendReadAck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
        var t;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              t = this._createUrl("/sdk/push/click");
              return _context2.abrupt("return", this._post(t, JSON.stringify(e)));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function sendReadAck(_x2) {
        return _sendReadAck.apply(this, arguments);
      }
      return sendReadAck;
    }()
  }, {
    key: "_createUrl",
    value: function _createUrl(e) {
      return "".concat(this._baseUrl).concat(e);
    }
  }, {
    key: "_createCommonHeaders",
    value: function _createCommonHeaders() {
      return {
        "Content-Type": "application/json"
      };
    }
  }, {
    key: "_post",
    value: function () {
      var _post2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e, s) {
        var r,
          _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              r = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
              return _context4.abrupt("return", t(e, {
                method: "post",
                body: s,
                headers: o({}, this._createCommonHeaders(), r)
              }).then( /*#__PURE__*/function () {
                var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
                  var t, s;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        t = e.status;
                        _context3.prev = 1;
                        _context3.next = 4;
                        return e.text();
                      case 4:
                        s = _context3.sent;
                        _context3.next = 10;
                        break;
                      case 7:
                        _context3.prev = 7;
                        _context3.t0 = _context3["catch"](1);
                        s = "";
                      case 10:
                        if (!(200 === t)) {
                          _context3.next = 12;
                          break;
                        }
                        return _context3.abrupt("return", s);
                      case 12:
                        throw {
                          status: t,
                          error: s
                        };
                      case 13:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3, null, [[1, 7]]);
                }));
                return function (_x5) {
                  return _ref13.apply(this, arguments);
                };
              }()));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function _post(_x3, _x4) {
        return _post2.apply(this, arguments);
      }
      return _post;
    }()
  }], [{
    key: "parseToyPushAckModel",
    value: function parseToyPushAckModel(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "receive";
      function s(e, t) {
        return g.includes(e) ? +t : t;
      }
      var r = "read" === t ? p : A,
        n = Object.entries(e).reduce(function (e, _ref14) {
          var _ref15 = _slicedToArray(_ref14, 2),
            t = _ref15[0],
            n = _ref15[1];
          return r.includes(t) ? (e[t] = s(t, n), e) : ("object" == _typeof(n) && null != n && Object.entries(n).forEach(function (_ref16) {
            var _ref17 = _slicedToArray(_ref16, 2),
              t = _ref17[0],
              n = _ref17[1];
            return r.includes(t) && (e[t] = s(t, n));
          }), e);
        }, {});
      return function (e) {
        var t = Object.keys(e);
        return r.every(function (e) {
          return t.includes(e);
        });
      }(n) ? n : null;
    }
  }]);
}();
var I = {
    local: {
      BASE_URL: "https://sandbox.api.nexon.com/toy-push/alpha"
    },
    dev: {
      BASE_URL: "https://sandbox.api.nexon.com/toy-push/alpha"
    },
    test: {
      BASE_URL: "https://sandbox.api.nexon.com/toy-push/qa"
    },
    pre: {
      BASE_URL: "https://sandbox.api.nexon.com/toy-push/pre"
    },
    live: {
      BASE_URL: "https://public.api.nexon.com/toy-push/live"
    },
    UNKNOWN: {
      BASE_URL: "https://sandbox.api.nexon.com/toy-push/UNKNOWN_ENV"
    }
  },
  m = f.parseToyPushAckModel;
function D() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "live";
  return new f((I[e] || I.UNKNOWN).BASE_URL);
}
var M = ["onMessage", "onError", "onEvent", "ok", "fail"],
  v = ["ok", "fail"],
  T = s("livestream").livestreamConnector,
  L = r && (r.isBrowser() ? "web" : "desktop"),
  b = Object.freeze({
    START: "start",
    STOP: "stop",
    INIT: "init"
  });
var y = /*#__PURE__*/function () {
  function y() {
    _classCallCheck(this, y);
    this._initListeners();
  }
  return _createClass(y, [{
    key: "env",
    get: function get() {
      var e = s("web-auth").getEnv;
      return e ? e() : this._env || "live";
    },
    set: function set(e) {
      return this._env = e;
    }
  }, {
    key: "info",
    get: function get() {
      return this._info;
    },
    set: function set(e) {
      this._info = e;
    }
  }, {
    key: "initialize",
    value: function initialize(e) {
      var _this = this;
      var t = e.onMessage,
        s = e.onError,
        r = e.onEvent,
        n = e.ok,
        a = e.fail,
        E = i(e, M);
      if (this.getStatus() !== b.STOP) {
        var _T$getInfo = T.getInfo(),
          _e3 = _T$getInfo.cid,
          _t = _T$getInfo.utoken,
          _s2 = _T$getInfo.ls_alias;
        if (!this._isAvailableRestart(E)) return this.env = T.getEnv() || "live", n({
          status: "success",
          cid: _e3,
          utoken: _t,
          ls_alias: _s2,
          code: c.IM_IS_NOT_STOPPED.CODE,
          message: "".concat(c.IM_IS_NOT_STOPPED.MESSAGE, ". Call finalize first to stop IM SDK")
        });
        this.finalize();
      }
      if (l(t) || l(r)) throw _({
        name: "initialize",
        code: c.INVALID_PARAMETER.CODE,
        message: "".concat(c.INVALID_PARAMETER.MESSAGE, ", check callback function"),
        other: {
          payload: E
        }
      });
      if (T.isStop()) {
        var _o2 = o({}, E),
          _e4 = _o2.gid;
        if (!_e4) throw _({
          name: "initialize",
          code: c.INVALID_PARAMETER.CODE,
          message: "".concat(c.INVALID_PARAMETER.MESSAGE, ", payload is supposed to involve gid when LS start"),
          other: {
            payload: E
          }
        });
      }
      this._addMessageListener({
        type: "*",
        onMessage: t
      }), this._addEventListener({
        type: "*",
        onEvent: r
      }), this._addErrorListener({
        type: "*",
        onError: s
      });
      var d = T.addEventListener("start", this._onLivestreamEvent.bind(this));
      if (this._setLSListener("start", d), d = T.addEventListener("stop", this._onLivestreamEvent.bind(this)), this._setLSListener("stop", d), d = T.addEventListener("im", this._onReceiveMessage.bind(this), this._onError.bind(this)), this._setLSListener("im", d), d = T.addEventListener("im-game", this._onReceiveMessage.bind(this), this._onError.bind(this)), this._setLSListener("im-game", d), this._setStatus(b.INIT), T.isStop() || this._isAvailableRestart(E)) try {
        T.initialize(o({
          path: E.gid
        }, E)).then(function (e) {
          _this._setStatus(b.START), _this.env = T.getEnv() || "live", n(e), _this._subscribeToPlatformEnv(E);
        }).catch(function (e) {
          T.finalize(), a(e);
        });
      } catch (e) {
        throw console.error(e), this.env = T.getEnv() || "live", _({
          name: "initialize",
          code: c.UNKNOWN.CODE,
          message: "".concat(c.UNKNOWN.MESSAGE),
          other: {
            payload: E,
            error: e
          }
        });
      } else if (T.isStart()) {
        this._setStatus(b.START), this.env = T.getEnv() || "live";
        var _T$getInfo2 = T.getInfo(),
          _e5 = _T$getInfo2.cid,
          _t2 = _T$getInfo2.utoken,
          _s3 = _T$getInfo2.ls_alias;
        n({
          status: "success",
          cid: _e5,
          utoken: _t2,
          ls_alias: _s3
        });
      }
    }
  }, {
    key: "_isAvailableRestart",
    value: function _isAvailableRestart(e) {
      var _T$getInfo3 = T.getInfo(),
        t = _T$getInfo3.path;
      return e.env && e.env !== this.env || t && e.gid !== t;
    }
  }, {
    key: "_subscribeToPlatformEnv",
    value: function _subscribeToPlatformEnv(_ref18) {
      var e = _ref18.gid;
      if (this.getStatus() !== b.START || !L) return !1;
      this.subscribe({
        gid: e,
        channel: [L]
      });
    }
  }, {
    key: "attachAuth",
    value: function attachAuth(e) {
      var t = e.ok,
        s = e.fail,
        r = i(e, v);
      if (this.getStatus() !== b.START) throw _({
        name: "sendInstantMessage",
        code: c.IM_IS_NOT_STARTED.CODE,
        message: c.IM_IS_NOT_STARTED.MESSAGE
      });
      if (T.isStop()) throw _({
        name: "sendInstantMessage",
        code: c.FAILED_SEND_MESSAGE_LS_STOPPED.CODE,
        message: "".concat(c.FAILED_SEND_MESSAGE_LS_STOPPED.MESSAGE),
        other: {
          target: target,
          message: message
        }
      });
      if (!r.access_token || !r.access_token_type) throw _({
        name: "attachAuth",
        code: c.INVALID_PARAMETER.CODE,
        message: "".concat(c.INVALID_PARAMETER.MESSAGE, ", payload is supposed to involve access token and access token type when LS attach auth"),
        other: {
          payload: r
        }
      });
      try {
        T.attachAuth({
          access_token: r.access_token,
          access_token_type: r.access_token_type
        }).then(function (e) {
          t(o({
            status: "success"
          }, e));
        }).catch(function (e) {
          s(e);
        });
      } catch (e) {
        throw console.error(e), _({
          name: "attachAuth",
          code: c.UNKNOWN.CODE,
          message: "".concat(c.UNKNOWN.MESSAGE),
          other: {
            payload: r,
            error: e
          }
        });
      }
    }
  }, {
    key: "sendInstantMessage",
    value: function sendInstantMessage(_ref19) {
      var e = _ref19.target,
        t = _ref19.message;
      if (this.getStatus() !== b.START) throw _({
        name: "sendInstantMessage",
        code: c.IM_IS_NOT_STARTED.CODE,
        message: c.IM_IS_NOT_STARTED.MESSAGE
      });
      if (T.isStop()) throw _({
        name: "sendInstantMessage",
        code: c.FAILED_SEND_MESSAGE_LS_STOPPED.CODE,
        message: "".concat(c.FAILED_SEND_MESSAGE_LS_STOPPED.MESSAGE),
        other: {
          target: e,
          message: t
        }
      });
      T.sendStream({
        target: e,
        message: t
      });
    }
  }, {
    key: "finalize",
    value: function finalize() {
      this.getStatus() !== b.STOP && (T.removeEventListener(this._getLSListener("start")), T.removeEventListener(this._getLSListener("stop")), T.removeEventListener(this._getLSListener("im")), T.removeEventListener(this._getLSListener("im-game")), this._initListeners());
    }
  }, {
    key: "addListeners",
    value: function addListeners(_ref20) {
      var _ref20$type = _ref20.type,
        e = _ref20$type === void 0 ? "*" : _ref20$type,
        t = _ref20.onMessage,
        s = _ref20.onEvent,
        r = _ref20.onError;
      if (this.getStatus() !== b.START) throw _({
        name: "addListeners",
        code: c.IM_IS_NOT_STARTED.CODE,
        message: c.IM_IS_NOT_STARTED.MESSAGE
      });
      if (l(t) && l(s) && l(r)) throw _({
        name: "addListeners",
        code: c.INVALID_PARAMETER.CODE,
        message: "".concat(c.INVALID_PARAMETER.MESSAGE, " type, onMessage or onEvent or onError is supposed to be function")
      });
      this._addMessageListener({
        type: "*",
        onMessage: t
      }), this._addEventListener({
        type: "*",
        onEvent: s
      }), this._addErrorListener({
        type: "*",
        onError: r
      });
    }
  }, {
    key: "removeListeners",
    value: function removeListeners(_ref21) {
      var _ref21$type = _ref21.type,
        e = _ref21$type === void 0 ? "*" : _ref21$type,
        t = _ref21.onMessage,
        s = _ref21.onEvent,
        r = _ref21.onError;
      if (this.getStatus() !== b.START) throw _({
        name: "removeListeners",
        code: c.IM_IS_NOT_STARTED.CODE,
        message: c.IM_IS_NOT_STARTED.MESSAGE
      });
      if (l(t) && l(s)) throw _({
        name: "removeListeners",
        code: c.INVALID_PARAMETER.CODE,
        message: "".concat(c.INVALID_PARAMETER.MESSAGE, " type, onMessage or onEvent or onError is supposed to be function")
      });
      this._removeMessageListener({
        type: "*",
        onMessage: t
      }), this._removeEventListener({
        type: "*",
        onEvent: s
      }), this._removeErrorListener({
        type: "*",
        onError: r
      });
    }
  }, {
    key: "getStatus",
    value: function getStatus() {
      return this._info.status;
    }
  }, {
    key: "_setStatus",
    value: function _setStatus(e) {
      this._info.status = e;
    }
  }, {
    key: "_initListeners",
    value: function _initListeners() {
      this._info = {
        onMessageList: [],
        onEventList: [],
        onErrorList: [],
        status: b.STOP,
        subscriptionObject: {},
        lsListenerObject: {}
      }, this._setStatus(b.STOP);
    }
  }, {
    key: "_setLSListener",
    value: function _setLSListener(e, t) {
      this._info.lsListenerObject || (this._info.lsListenerObject = {}), this._info.lsListenerObject[e] = t;
    }
  }, {
    key: "_getLSListener",
    value: function _getLSListener(e) {
      return this._info.lsListenerObject || (this._info.lsListenerObject = {}), this._info.lsListenerObject[e];
    }
  }, {
    key: "_addMessageListener",
    value: function _addMessageListener(_ref22) {
      var _ref22$type = _ref22.type,
        e = _ref22$type === void 0 ? "*" : _ref22$type,
        t = _ref22.onMessage;
      "function" != typeof t || this._info.onMessageList.some(function (e) {
        return e === t;
      }) || this._info.onMessageList.push(t);
    }
  }, {
    key: "_addEventListener",
    value: function _addEventListener(_ref23) {
      var _ref23$type = _ref23.type,
        e = _ref23$type === void 0 ? "*" : _ref23$type,
        t = _ref23.onEvent;
      "function" != typeof t || this._info.onEventList.some(function (e) {
        return e === t;
      }) || this._info.onEventList.push(t);
    }
  }, {
    key: "_addErrorListener",
    value: function _addErrorListener(_ref24) {
      var _ref24$type = _ref24.type,
        e = _ref24$type === void 0 ? "*" : _ref24$type,
        t = _ref24.onError;
      "function" != typeof t || this._info.onErrorList.some(function (e) {
        return e === t;
      }) || this._info.onErrorList.push(t);
    }
  }, {
    key: "_removeMessageListener",
    value: function _removeMessageListener(_ref25) {
      var _this2 = this;
      var _ref25$type = _ref25.type,
        e = _ref25$type === void 0 ? "*" : _ref25$type,
        t = _ref25.onMessage;
      if ("function" == typeof t) {
        var _e6 = [];
        this._info.onMessageList.forEach(function (s, r) {
          s === t && _e6.push(r);
        }), _e6.reverse().forEach(function (e) {
          return _this2._info.onMessageList.splice(e, 1);
        });
      }
    }
  }, {
    key: "_removeEventListener",
    value: function _removeEventListener(_ref26) {
      var _this3 = this;
      var e = _ref26.onEvent;
      if ("function" == typeof e) {
        var _t3 = [];
        this._info.onEventList.forEach(function (s, r) {
          s === e && _t3.push(r);
        }), _t3.reverse().forEach(function (e) {
          return _this3._info.onMessageList.splice(e, 1);
        });
      }
    }
  }, {
    key: "_removeErrorListener",
    value: function _removeErrorListener(_ref27) {
      var _this4 = this;
      var e = _ref27.onError;
      "function" == typeof e && this._info.onErrorList.map(function (t, s) {
        return t === e ? s : -1;
      }).filter(function (e) {
        return e > -1;
      }).reverse().forEach(function (e) {
        return _this4._info.onErrorList.splice(e, 1);
      });
    }
  }, {
    key: "addGID",
    value: function addGID(_ref28) {
      var e = _ref28.ok,
        t = _ref28.fail,
        s = _ref28.gid,
        r = _ref28.web_token;
      if (this.getStatus() !== b.START) throw _({
        name: "addGID",
        code: c.IM_IS_NOT_STARTED.CODE,
        message: c.IM_IS_NOT_STARTED.MESSAGE,
        other: {
          gid: s,
          web_token: r
        }
      });
      if (!s || "string" != typeof s) throw _({
        name: "addGID",
        code: c.INVALID_PARAMETER.CODE,
        message: "".concat(c.INVALID_PARAMETER.MESSAGE, ", 'gid' is supposed to be string"),
        other: {
          gid: s,
          web_token: r
        }
      });
      if (!r || "string" != typeof r) throw _({
        name: "addGID",
        code: c.INVALID_PARAMETER.CODE,
        message: "".concat(c.INVALID_PARAMETER.MESSAGE, ", 'web_token' is supposed to be string"),
        other: {
          gid: s,
          web_token: r
        }
      });
      try {
        T.addGID({
          gid: s,
          web_token: r
        }).then(function (t) {
          e(o({
            status: "success"
          }, t));
        }).catch(function (e) {
          t(e);
        });
      } catch (e) {
        throw console.error(e), _({
          name: "addGID",
          code: c.UNKNOWN.CODE,
          message: "".concat(c.UNKNOWN.MESSAGE),
          other: {
            gid: s,
            web_token: r,
            error: e
          }
        });
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe(_ref29) {
      var e = _ref29.gid,
        t = _ref29.channel;
      if (this.getStatus() !== b.START) throw _({
        name: "subscribe",
        code: c.IM_IS_NOT_STARTED.CODE,
        message: c.IM_IS_NOT_STARTED.MESSAGE,
        other: {
          gid: e,
          channel: t
        }
      });
      if (!e || "string" != typeof e) throw _({
        name: "subscribe",
        code: c.INVALID_PARAMETER.CODE,
        message: "".concat(c.INVALID_PARAMETER.MESSAGE, ", 'gid' is supposed to be string"),
        other: {
          gid: e,
          channel: t
        }
      });
      if (t && "string" != typeof t && !Array.isArray(t)) throw _({
        name: "subscribe",
        code: c.INVALID_PARAMETER.CODE,
        message: "".concat(c.INVALID_PARAMETER.MESSAGE, ", 'channel' is supposed to be string or string array or null"),
        other: {
          gid: e,
          channel: t
        }
      });
      t ? "string" == typeof t && (t = [t]) : t = [];
      var s = this._info.subscriptionObject[e] || [],
        r = t.filter(function (e) {
          return !s.some(function (t) {
            return e === t;
          });
        });
      t.length ? r.length && (T.subscribe({
        path: e,
        path_suffix: r,
        stream: "im-game"
      }), this._info.subscriptionObject[e] = s.concat(r)) : (T.subscribe({
        path: e,
        stream: "im-game"
      }), this._info.subscriptionObject[e] = s.concat(["<**/?>"]));
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(_ref30) {
      var e = _ref30.gid,
        t = _ref30.channel;
      if (this.getStatus() !== b.START) throw _({
        name: "unsubscribe",
        code: c.IM_IS_NOT_STARTED.CODE,
        message: c.IM_IS_NOT_STARTED.MESSAGE,
        other: {
          gid: e,
          channel: t
        }
      });
      if ("string" != typeof e) throw _({
        name: "unsubscribe",
        code: c.INVALID_PARAMETER.CODE,
        message: "".concat(c.INVALID_PARAMETER.MESSAGE, ", 'gid' is supposed to be string"),
        other: {
          gid: e,
          channel: t
        }
      });
      if (t && "string" != typeof t && !Array.isArray(t)) throw _({
        name: "unsubscribe",
        code: c.INVALID_PARAMETER.CODE,
        message: "".concat(c.INVALID_PARAMETER.MESSAGE, ", 'channel' is supposed to be string, string array or null"),
        other: {
          gid: e,
          channel: t
        }
      });
      t ? "string" == typeof t && (t = [t]) : t = [];
      var s = this._info.subscriptionObject[e];
      s && Array.isArray(s) && (T.unsubscribe({
        path: e,
        path_suffix: t,
        stream: "im-game"
      }), t.length || (t = ["<**/?>"]), s.map(function (e, s) {
        return t.some(function (t) {
          return e === t;
        }) ? s : -1;
      }).filter(function (e) {
        return e > -1;
      }).reverse().forEach(function (e) {
        return s.splice(e, 1);
      }));
    }
  }, {
    key: "unsubscribeAll",
    value: function unsubscribeAll(_ref31) {
      var e = _ref31.gid;
      if (this.getStatus() !== b.START) throw _({
        name: "unsubscribeAll",
        code: c.IM_IS_NOT_STARTED.CODE,
        message: c.IM_IS_NOT_STARTED.MESSAGE,
        other: {
          gid: e
        }
      });
      if (e && "string" != typeof e) throw _({
        name: "unsubscribeAll",
        code: c.INVALID_PARAMETER.CODE,
        message: "".concat(c.INVALID_PARAMETER.MESSAGE, ", 'gid' is supposed to be string"),
        other: {
          gid: e
        }
      });
      for (var _i3 = 0, _Object$entries = Object.entries(this._info.subscriptionObject); _i3 < _Object$entries.length; _i3++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2),
          _t4 = _Object$entries$_i[0],
          _s4 = _Object$entries$_i[1];
        if (void 0 === e || e === _t4) {
          if (!_s4 || !_s4.length) continue;
          var _r3 = _s4.indexOf("<**/?>");
          -1 !== _r3 && (T.unsubscribe({
            path: e,
            stream: "im-game"
          }), _s4.splice(_r3, 1)), T.unsubscribe({
            path: _t4,
            path_suffix: _s4,
            stream: "im-game"
          }), delete this._info.subscriptionObject[_t4];
        }
      }
    }
  }, {
    key: "_sendEventToEventListeners",
    value: function _sendEventToEventListeners(_ref32) {
      var _this5 = this;
      var _ref32$type = _ref32.type,
        e = _ref32$type === void 0 ? u.IM_EVENT : _ref32$type,
        _ref32$data = _ref32.data,
        t = _ref32$data === void 0 ? "" : _ref32$data,
        s = _ref32.ImEvent;
      var r = [];
      this._info.onEventList.forEach(function (n) {
        "function" == typeof n ? n(function (_ref33) {
          var _ref33$type = _ref33.type,
            e = _ref33$type === void 0 ? u.IM_EVENT : _ref33$type,
            _ref33$data = _ref33.data,
            t = _ref33$data === void 0 ? "" : _ref33$data,
            s = _ref33.ImEvent;
          if (!t && !s) throw new Error("INVALID PARAMETERS");
          return !t && s && (t = {
            message: "".concat(s.MESSAGE, " [").concat(s.CODE, "]")
          }), {
            type: e,
            data: t
          };
        }({
          type: e,
          data: t,
          ImEvent: s
        })) : r.push(idx);
      }), r.reverse().forEach(function (e) {
        return _this5._info.onEventList.splice(e, 1);
      });
    }
  }, {
    key: "_sendErrorToErrorListeners",
    value: function _sendErrorToErrorListeners(_ref34) {
      var _this6 = this;
      var t = _ref34.event,
        s = _ref34.payload,
        r = _ref34.errorCode,
        n = _ref34.errorMessage;
      var o = E({
          SDKError: e,
          event: t,
          payload: s,
          errorCode: r,
          errorMessage: n
        }),
        i = [];
      this._info.onErrorList.forEach(function (e, t) {
        "function" == typeof e ? e(o) : i.push(t);
      }), i.reverse().forEach(function (e) {
        return _this6._info.onErrorList.splice(e, 1);
      });
    }
  }, {
    key: "ackToyPushMessageRead",
    value: function () {
      var _ackToyPushMessageRead2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref35) {
        var e, t, s;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              e = _ref35.svcId, t = _ref35.pushId, s = _ref35.udid;
              _context5.t0 = !!(e && t && s);
              if (!_context5.t0) {
                _context5.next = 6;
                break;
              }
              _context5.next = 5;
              return this._ackToyPushMessageRead({
                svcId: e,
                pushId: t,
                udid: s
              });
            case 5:
              _context5.t0 = _context5.sent;
            case 6:
              return _context5.abrupt("return", _context5.t0);
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function ackToyPushMessageRead(_x6) {
        return _ackToyPushMessageRead2.apply(this, arguments);
      }
      return ackToyPushMessageRead;
    }()
  }, {
    key: "_ackToyPushMessageRead",
    value: function () {
      var _ackToyPushMessageRead3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e) {
        var _t5;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _t5 = D(this.env);
              _context6.next = 4;
              return _t5.sendReadAck(e);
            case 4:
              return _context6.abrupt("return", !0);
            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](0);
              return _context6.abrupt("return", (void 0, !1));
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 7]]);
      }));
      function _ackToyPushMessageRead(_x7) {
        return _ackToyPushMessageRead3.apply(this, arguments);
      }
      return _ackToyPushMessageRead;
    }()
  }, {
    key: "_ackToyPushMessageReceive",
    value: function _ackToyPushMessageReceive(e) {
      var t = m(e.message);
      t && D(this.env).sendReceiveAck(t).then(function (e) {}).catch(function (e) {
        return void 0;
      });
    }
  }, {
    key: "_onLivestreamEvent",
    value: function _onLivestreamEvent(e) {
      var t = e.status;
      void 0, t !== b.START && t !== b.STOP || this._setStatus(t || "stop");
    }
  }, {
    key: "_onReceiveMessage",
    value: function _onReceiveMessage(_ref36) {
      var _this7 = this;
      var e = _ref36.type,
        t = _ref36.body;
      var s = new RegExp("^(im::sdk_event::).*");
      if (["im-game::subscribe_event", "im::user_event"].includes(e) || s.test(e)) {
        this._ackToyPushMessageReceive(t);
        var _s5 = function (e) {
            if ("string" == typeof e) switch (e) {
              case "ls::connect":
              case "ls::create_utoken":
              case "ls::auth":
                return "im::initialize";
            }
            return e;
          }(e),
          _r4 = [];
        this._info.onMessageList.forEach(function (e, n) {
          "function" == typeof e ? e({
            type: _s5,
            data: t
          }) : _r4.push(n);
        }), _r4.reverse().forEach(function (e) {
          return _this7._info.onMessageList.splice(e, 1);
        });
      }
    }
  }, {
    key: "_onError",
    value: function _onError() {
      var _this8 = this;
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }
      var t = [];
      this._info.onErrorList.forEach(function (s, r) {
        "function" == typeof s ? s.apply(void 0, e) : t.push(r);
      }), t.reverse().forEach(function (e) {
        return _this8._info.onErrorList.splice(e, 1);
      });
    }
  }]);
}();
var O = null;
try {
  var _e7 = s("livestream").livestreamConnector,
    _t6 = new y(),
    _r5 = function (_ref37) {
      var e = _ref37.ls,
        t = _ref37.im;
      return {
        initialize: function initialize(e) {
          var _e$gid = e.gid,
            s = _e$gid === void 0 ? "" : _e$gid,
            r = i(e, d);
          var n = r.onMessage || function (e) {
              return void 0;
            },
            a = r.onEvent || function (e) {
              return void 0;
            },
            c = r.env;
          return new Promise(function (e, i) {
            try {
              t.initialize(o({
                ok: function ok(t) {
                  return e(t);
                },
                fail: function fail(e) {
                  return i(e);
                },
                onMessage: n,
                onEvent: a,
                gid: s,
                access_token: r.accessToken,
                access_token_type: r.accessTokenType,
                env: c
              }, r));
            } catch (e) {
              i(e);
            }
          });
        },
        finalize: function finalize() {
          t.finalize(), e && e.finalize();
        },
        getStatus: function getStatus() {
          var s = e.isStop() ? "stop" : null;
          return s || (s = e.isStart() ? "start" : "standby"), {
            livestream: s,
            im: t.getStatus()
          };
        },
        ackToyPushMessageRead: function () {
          var _ackToyPushMessageRead4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
            var _ref38,
              e,
              s,
              r,
              _args7 = arguments;
            return _regeneratorRuntime().wrap(function _callee7$(_context7) {
              while (1) switch (_context7.prev = _context7.next) {
                case 0:
                  _ref38 = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {}, e = _ref38.svcId, s = _ref38.pushId, r = _ref38.udid;
                  _context7.prev = 1;
                  _context7.next = 4;
                  return t.ackToyPushMessageRead({
                    svcId: e,
                    pushId: s,
                    udid: r
                  });
                case 4:
                  return _context7.abrupt("return", _context7.sent);
                case 7:
                  _context7.prev = 7;
                  _context7.t0 = _context7["catch"](1);
                  return _context7.abrupt("return", (console.error("ackToyPushMessageRead error ", _context7.t0), !1));
                case 10:
                case "end":
                  return _context7.stop();
              }
            }, _callee7, null, [[1, 7]]);
          }));
          function ackToyPushMessageRead() {
            return _ackToyPushMessageRead4.apply(this, arguments);
          }
          return ackToyPushMessageRead;
        }(),
        attachAuth: function attachAuth(e) {
          var s = o({}, e);
          return new Promise(function (e, r) {
            try {
              t.attachAuth(o({
                access_token: s.accessToken || s.access_token,
                access_token_type: s.accessTokenType || s.access_token_type,
                ok: function ok(t) {
                  return e(t);
                },
                fail: function fail(e) {
                  return r(e);
                }
              }, s));
            } catch (e) {
              r(e);
            }
          });
        },
        addGID: function addGID(e) {
          var s = o({}, e);
          return new Promise(function (e, r) {
            try {
              t.addGID(o({
                web_token: s.webToken || s.web_token,
                ok: function ok(t) {
                  return e(t);
                },
                fail: function fail(e) {
                  return r(e);
                }
              }, s));
            } catch (e) {
              r(e);
            }
          });
        },
        sendInstantMessage: function sendInstantMessage() {
          return t.sendInstantMessage.apply(t, arguments);
        },
        addListeners: function addListeners() {
          return t.addListeners.apply(t, arguments);
        },
        removeListeners: function removeListeners() {
          return t.removeListeners.apply(t, arguments);
        },
        subscribe: function subscribe() {
          return t.subscribe.apply(t, arguments);
        },
        unsubscribe: function unsubscribe() {
          return t.unsubscribe.apply(t, arguments);
        },
        unsubscribeAll: function unsubscribeAll() {
          return t.unsubscribeAll.apply(t, arguments);
        }
      };
    }({
      ls: _e7,
      im: _t6
    });
  O = n.register({
    name: "im",
    version: process.env.__im_version || "__im_version",
    description: process.env.__im_description || "__im_description",
    rawApis: h(_t6),
    sdkApis: [{
      name: "instantMessage",
      action: _r5
    }]
  });
} catch (e) {}
var R = O;
export default R;